import axios from 'axios'
import store from './state/store'

const baseUrlProd = 'https://pphback.metacoresystemsinc.com/api/'

const axiosInstance = axios.create({
    baseURL: baseUrlProd
})

axiosInstance.interceptors.request.use(
    (config) => {
        const token = store.state.accessToken
        if (token) {
            config.headers.Authorization = `Bearer ${token}`
        }
        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

export default axiosInstance